import React from "react"
import styled from "styled-components"
import { StaticQuery } from "gatsby"
import Img from "gatsby-image"
import { Grid } from "../../atoms/grid"
import { Settings } from "../../../styles/theme"
import { FullCard } from "../../atoms/card"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import some from "lodash.some"
import pull from "lodash.pull"
import includes from "lodash.includes"
import { array } from "prop-types"
import Reset from "../../../images/icons/reset.png"

const FilterStyle = styled.div`
  display: none;
  position: absolute;
  left: 50%;
  top: 100%;
  z-index: 999;
  transform: translate(-50%, -10%);
  width: 90%;
  > div {
    align-items: stretch;
    > div {
      background: #edeff0;
      border: 1px solid #fff;
      cursor: pointer;
    }
  }
  .active {
    background: ${Settings.secondaryColor};
    color: ${"#fff"};
  }
`

const DisplayStyle = styled.div`
  .hover {
    cursor: pointer;
  }
  .red {
    color: ${Settings.secondaryColor};
  }
  position: relative;
  hr {
    border: 1.5px solid ${Settings.secondaryColor};
  }
  .lightbox {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 5000;
    top: 0;
    left: 0;
    pointer-events: none;
    opacity: 0;
    transition: opacity 175ms ease-in-out;
    > span {
      cursor: pointer;
      font-size: 1.2rem;
      color: #fff;
      font-weight: 700;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 2;
      &:first-of-type {
        left: 5%;
      }
      &:last-of-type {
        right: 5%;
      }
    }
    .background {
      background: rgba(0, 0, 0, 0.8);
      z-index: 1;
      left: 0;
      top: 0;
      transform: none;
      height: 100vh;
      width: 100vw;
    }
    > div {
      background: #fff;
      padding: 5rem 2rem;
      max-width: 1040px;
      width: 80%;
      position: absolute;
      z-index: 4;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      > span {
        position: absolute;
        top: 1rem;
        right: 1rem;
        color: ${Settings.secondaryColor};
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
  .lightbox.show {
    opacity: 1;
    pointer-events: all;
    h5 {
      font-size: 0.8rem;
      margin: 0;
    }
    h3 {
      margin: 0;
      font-size: 1.4rem;
      text-transform: uppercase;
    }
    h3,
    h5 {
      color: ${Settings.primaryColor};
    }
    h4 {
      color: ${Settings.secondaryColor};
      font-size: 0.9rem;
    }
    p {
      font-size: 0.8rem;
    }
  }
  .filter {
    > div {
      position: relative;
    }
    div {
      text-align: center;
    }
    h3 {
      cursor: pointer;
      margin: 0 1rem;
    }
  }
  .card-wrap {
    display: none;
  }
  .card-wrap.active {
    display: block;
  }
  .hover {
    &:hover {
      > div {
        display: block !important;
      }
    }
  }
`

class Staticc extends React.Component {
  constructor(props) {
    super(props)
    const displays = props.props.allContentfulStaticDisplayOrder.edges[0].node.staticDisplays.map(
      o => ({
        ...o,
        valid: true,
      })
    )
    let countries = []
    let cats = []
    let types = []
    displays.map(display => {
      countries.push(display.country)
      cats.push(display.category)
      types.push(display.type)
    })
    let countryStates = [...new Set(countries)]
    let categoryStates = [...new Set(cats)]
    let typeStates = [...new Set(types)]
    this.state = {
      selected: 0,
      toggled: false,
      displays: displays,
      countries: countryStates,
      types: typeStates,
      categories: categoryStates,
      countrySelected: [],
      typeSelected: [],
      categorySelected: [],
      titleSelected: [],
      valid: [],
    }
  }

  validate = () => {
    const countries = this.state.countrySelected
    const types = this.state.typeSelected
    const categories = this.state.categorySelected
    let displays = this.state.displays
    const skip =
      countries.length === 0 && types.length === 0 && categories.length === 0
    if (!skip) {
      displays.forEach(function(display) {
        let valid = false
        let countriesBool = false
        let typesBool = false
        let categoriesBool = false
        if (countries.length > 0) {
          if (includes(countries, display.country)) {
            countriesBool = true
          }
        }
        if (types.length > 0) {
          if (includes(types, display.type)) {
            typesBool = true
          }
        }
        if (categories.length > 0) {
          if (includes(categories, display.category)) {
            categoriesBool = true
          }
        }
        if (countriesBool || typesBool || categoriesBool) {
          valid = true
        }
        display.valid = valid
      })
    } else {
      displays.forEach(function(display) {
        display.valid = true
      })
    }
    this.setState({
      displays: displays,
    })
  }

  countrySelected = element => {
    let countries = this.state.countrySelected
    !includes(countries, element)
      ? countries.push(element)
      : pull(countries, element)
    this.setState({
      countrySelected: countries,
    })
    this.validate()
  }

  resetStates = () => {
    let displays = this.state.displays
    displays.map(display => (display.valid = true))
    this.setState({
      countrySelected: [],
      typeSelected: [],
      categorySelected: [],
      displays: displays,
    })
  }

  categorySelected = element => {
    let categories = this.state.categorySelected
    !includes(categories, element)
      ? categories.push(element)
      : pull(categories, element)
    this.setState({
      categorySelected: categories,
    })
    this.validate()
  }

  typeSelected = element => {
    let categories = this.state.typeSelected
    !includes(categories, element)
      ? categories.push(element)
      : pull(categories, element)
    this.setState({
      typeSelected: categories,
    })
    this.validate()
  }

  setToggled = i => {
    this.setState({
      selected: i,
    })
  }

  toggle = () => {
    this.setState({
      toggled: !this.state.toggled,
    })
  }
  render() {
    return (
      <DisplayStyle>
        <div className={this.state.toggled ? "lightbox show" : "lightbox"}>
          <span
            onClick={() => this.setToggled(this.state.selected - 1)}
            style={{ display: this.state.selected === 0 ? "none" : "block" }}
          >
            {"<"}
          </span>
          <Grid columns={2}>
            <span onClick={() => this.toggle()}>X</span>
            <div className="content">
              <div style={{ marginBottom: "1rem" }}>
                <h3>
                  {
                    this.props.props.allContentfulStaticDisplayOrder.edges[0]
                      .node.staticDisplays[this.state.selected].title
                  }
                </h3>
                <h5>
                  <b>
                    {
                      this.props.props.allContentfulStaticDisplayOrder.edges[0]
                        .node.staticDisplays[this.state.selected].country
                    }
                  </b>{" "}
                  ·{" "}
                  {
                    this.props.props.allContentfulStaticDisplayOrder.edges[0]
                      .node.staticDisplays[this.state.selected].company
                  }
                </h5>
                <h4>
                  <b>> Category:</b>{" "}
                  {
                    this.props.props.allContentfulStaticDisplayOrder.edges[0]
                      .node.staticDisplays[this.state.selected].category
                  }
                </h4>
                <h4>
                  <b>> Type:</b>{" "}
                  {
                    this.props.props.allContentfulStaticDisplayOrder.edges[0]
                      .node.staticDisplays[this.state.selected].type
                  }
                </h4>
              </div>
              <p>
                {documentToReactComponents(
                  this.props.props.allContentfulStaticDisplayOrder.edges[0].node
                    .staticDisplays[this.state.selected].description.json
                )}
              </p>
            </div>
            <div>
              <Img
                fluid={
                  this.props.props.allContentfulStaticDisplayOrder.edges[0].node
                    .staticDisplays[this.state.selected].image.fluid
                }
              />
            </div>
          </Grid>
          <span className="background" onClick={() => this.toggle()} />
          <span
            onClick={() => this.setToggled(this.state.selected + 1)}
            style={{
              display:
                this.state.displays.length - 1 === this.state.selected
                  ? "none"
                  : "block",
            }}
          >
            {">"}
          </span>
        </div>
        <div className="constraint">
          <div className="constraint filter">
            <Grid unstack columns={5}>
              <div>
                <h3
                  className={
                    this.state.countrySelected.length == 0 &&
                    this.state.typeSelected.length == 0 &&
                    this.state.categorySelected == 0
                      ? "red"
                      : ""
                  }
                >
                  ALL
                </h3>
              </div>
              <div className="hover">
                <h3
                  className={this.state.countrySelected.length > 0 ? "red" : ""}
                >
                  COUNTRY
                </h3>
                <FilterStyle>
                  <Grid columns={4}>
                    {this.state.countries.map((country, i) => (
                      <div
                        key={i}
                        onClick={() => this.countrySelected(country)}
                        className={
                          includes(this.state.countrySelected, country)
                            ? "active"
                            : ""
                        }
                      >
                        <p>{country}</p>
                      </div>
                    ))}
                  </Grid>
                </FilterStyle>
              </div>
              <div className="hover">
                <h3
                  className={
                    this.state.categorySelected.length > 0 ? "red" : ""
                  }
                >
                  CATEGORY
                </h3>
                <FilterStyle>
                  <Grid columns={4}>
                    {this.state.categories.map((category, i) => (
                      <div
                        key={i}
                        onClick={() => this.categorySelected(category)}
                        className={
                          includes(this.state.categorySelected, category)
                            ? "active"
                            : ""
                        }
                      >
                        <p>{category}</p>
                      </div>
                    ))}
                  </Grid>
                </FilterStyle>
              </div>
              <div className="hover">
                <h3 className={this.state.typeSelected.length > 0 ? "red" : ""}>
                  TYPE
                </h3>

                <FilterStyle>
                  <Grid columns={4}>
                    {this.state.types.map((type, i) => (
                      <div
                        key={i}
                        onClick={() => this.typeSelected(type)}
                        className={
                          includes(this.state.typeSelected, type)
                            ? "active"
                            : ""
                        }
                      >
                        <p>{type}</p>
                      </div>
                    ))}
                  </Grid>
                </FilterStyle>
              </div>
              <div style={{ textAlign: "right" }}>
                <img
                  src={Reset}
                  style={{ width: "32px", height: "32px" }}
                  className="hover"
                  onClick={() => this.resetStates()}
                />
              </div>
            </Grid>
          </div>
          <hr />
          <Grid>
            {this.state.displays.map((display, i) => (
              <div
                onClick={() => {
                  this.setToggled(i)
                  this.toggle()
                }}
                className={display.valid ? "card-wrap active" : " card-wrap "}
              >
                <FullCard key={i} object={display} />
              </div>
            ))}
          </Grid>
        </div>
      </DisplayStyle>
    )
  }
}

export const StaticDisplays = () => (
  <StaticQuery
    query={graphql`
      query DisplayQuery {
        allContentfulStaticDisplayOrder {
          edges {
            node {
              staticDisplays {
                id
                title
                company
                type
                country
                category
                image {
                  fluid {
                    ...GatsbyContentfulFluid
                  }
                }
                description {
                  json
                }
              }
            }
          }
        }
      }
    `}
    render={data => <Staticc props={data} />}
  />
)
